import { EngagementStepStatus, EngagementTaskStatus } from '@aiwyn/api';
import { SharedModule } from '@aiwyn/shared';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ENGAGEMENT_STEP_FAILED_MESSAGE, EngagementStepDisplay } from '../../models';

@Component({
  selector: 'app-engagement-step-item',
  templateUrl: './engagement-step-item.component.html',
  styleUrls: ['./engagement-step-item.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule],
})
export class EngagementStepItemComponent {
  @Input() step: EngagementStepDisplay;

  readonly EngagementStepStatus = EngagementStepStatus;
  readonly ENGAGEMENT_STEP_FAILED_MESSAGE = ENGAGEMENT_STEP_FAILED_MESSAGE;
  readonly EngagementTaskStatus = EngagementTaskStatus;
}
